module.exports = "/_next/static/resources/life1-e79f24c489ea4f1787a14dcf02a11d21.jpg";